import { Container, Title, Grid, Card, Text, Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconServer, IconBrandWordpress, IconActivity, IconKey, IconPhoto } from '@tabler/icons-react';

export default function Dashboard() {
    return (
        <Container size="xl">
            <Title order={1} mb="xl">
                WordPress MCP Dashboard
            </Title>

            <Grid>
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section p="md">
                            <IconBrandWordpress size={48} />
                        </Card.Section>
                        <Text fw={500} size="lg" mb="xs">
                            WordPress Sites
                        </Text>
                        <Text size="sm" c="dimmed" mb="md">
                            Manage your WordPress instances
                        </Text>
                        <Button component={Link} to="/sites" variant="light" fullWidth>
                            Manage Sites
                        </Button>
                    </Card>
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section p="md">
                            <IconServer size={48} />
                        </Card.Section>
                        <Text fw={500} size="lg" mb="xs">
                            MCP Server
                        </Text>
                        <Text size="sm" c="dimmed" mb="md">
                            View server status and tools
                        </Text>
                        <Button component={Link} to="/mcp-status" variant="light" fullWidth>
                            View Status
                        </Button>
                    </Card>
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section p="md">
                            <IconKey size={48} />
                        </Card.Section>
                        <Text fw={500} size="lg" mb="xs">
                            API Keys
                        </Text>
                        <Text size="sm" c="dimmed" mb="md">
                            Manage MCP client authentication
                        </Text>
                        <Button component={Link} to="/api-keys" variant="light" fullWidth>
                            Manage Keys
                        </Button>
                    </Card>
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section p="md">
                            <IconPhoto size={48} />
                        </Card.Section>
                        <Text fw={500} size="lg" mb="xs">
                            Media Upload
                        </Text>
                        <Text size="sm" c="dimmed" mb="md">
                            Upload images directly to WordPress
                        </Text>
                        <Button component={Link} to="/media" variant="light" fullWidth>
                            Upload Media
                        </Button>
                    </Card>
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section p="md">
                            <IconActivity size={48} />
                        </Card.Section>
                        <Text fw={500} size="lg" mb="xs">
                            Activity Logs
                        </Text>
                        <Text size="sm" c="dimmed" mb="md">
                            View recent MCP operations
                        </Text>
                        <Button variant="light" fullWidth disabled>
                            Coming Soon
                        </Button>
                    </Card>
                </Grid.Col>
            </Grid>
        </Container>
    );
}
